export interface Country {
    name: string;
    code: string;
    states: State[];
}

export interface State {
    name: string;
    code: string;
    cities: string[];
}

export const USA_DATA: Country = {
    name: "United States",
    code: "US",
    states: [
        {
            name: "Alabama",
            code: "AL",
            cities: [
                "Birmingham",
                "Montgomery",
                "Huntsville",
                "Mobile",
                "Tuscaloosa",
            ],
        },
        {
            name: "Arizona",
            code: "AZ",
            cities: [
                "Phoenix",
                "Mesa",
                "Scottsdale",
                "Chandler",
                "Gilbert",
                "Tempe",
                "Glendale",
                "Peoria",
                "Surprise",
                "Tucson",
                "Yuma",
                "Flagstaff",
            ],
        },
        {
            name: "Arkansas",
            code: "AR",
            cities: [
                "Little Rock",
                "North Little Rock",
                "Fayetteville",
                "Springdale",
                "Fort Smith",
                "Jonesboro",
            ],
        },
        {
            name: "California",
            code: "CA",
            cities: [
                "Los Angeles",
                "San Diego",
                "San Jose",
                "San Francisco",
                "Oakland",
                "Berkeley",
                "Fremont",
                "Santa Clara",
                "Sunnyvale",
                "Mountain View",
                "Palo Alto",
                "Redwood City",
                "San Mateo",
                "San Bruno",
                "Daly City",
                "South San Francisco",
                "Santa Rosa",
                "Sacramento",
                "Stockton",
                "Modesto",
                "Fresno",
                "Bakersfield",
                "Visalia",
                "Riverside",
                "San Bernardino",
                "Ontario",
                "Rancho Cucamonga",
                "Fontana",
                "Moreno Valley",
                "Corona",
                "Anaheim",
                "Irvine",
                "Santa Ana",
                "Huntington Beach",
                "Costa Mesa",
                "Newport Beach",
                "Long Beach",
                "Torrance",
                "Pasadena",
                "Glendale",
                "Burbank",
                "Santa Monica",
                "Culver City",
                "Inglewood",
                "Compton",
                "Carson",
                "West Hollywood",
                "Beverly Hills",
                "Palm Springs",
                "Indio",
                "Coachella",
                "Oxnard",
                "Ventura",
                "Thousand Oaks",
                "Simi Valley",
                "Santa Barbara",
            ],
        },
        {
            name: "Colorado",
            code: "CO",
            cities: [
                "Denver",
                "Aurora",
                "Lakewood",
                "Littleton",
                "Arvada",
                "Westminster",
                "Thornton",
                "Broomfield",
                "Boulder",
                "Fort Collins",
                "Loveland",
                "Greeley",
                "Colorado Springs",
                "Pueblo",
            ],
        },
        {
            name: "Connecticut",
            code: "CT",
            cities: [
                "Bridgeport",
                "Stamford",
                "Norwalk",
                "Danbury",
                "New Haven",
                "Waterbury",
                "Hartford",
            ],
        },
        {
            name: "Delaware",
            code: "DE",
            cities: [
                "Wilmington",
                "Newark",
                "Dover",
            ],
        },
        {
            name: "Florida",
            code: "FL",
            cities: [
                "Miami",
                "Miami Beach",
                "Hialeah",
                "Fort Lauderdale",
                "Hollywood",
                "Pembroke Pines",
                "Coral Springs",
                "West Palm Beach",
                "Boca Raton",
                "Delray Beach",
                "Boynton Beach",
                "Palm Beach Gardens",
                "Orlando",
                "Kissimmee",
                "Sanford",
                "Winter Park",
                "Tampa",
                "St. Petersburg",
                "Clearwater",
                "Brandon",
                "Lakeland",
                "Jacksonville",
                "St. Augustine",
                "Tallahassee",
                "Gainesville",
                "Ocala",
                "Cape Coral",
                "Fort Myers",
                "Naples",
                "Sarasota",
                "Bradenton",
                "Pensacola",
                "Panama City",
            ],
        },
        {
            name: "Georgia",
            code: "GA",
            cities: [
                "Atlanta",
                "Sandy Springs",
                "Roswell",
                "Alpharetta",
                "Marietta",
                "Smyrna",
                "Duluth",
                "Lawrenceville",
                "Johns Creek",
                "Decatur",
                "Brookhaven",
                "Peachtree Corners",
                "Savannah",
                "Augusta",
                "Columbus",
                "Macon",
                "Athens",
            ],
        },
        {
            name: "Illinois",
            code: "IL",
            cities: [
                "Chicago",
                "Evanston",
                "Skokie",
                "Oak Park",
                "Cicero",
                "Berwyn",
                "Naperville",
                "Aurora",
                "Elgin",
                "Joliet",
                "Bolingbrook",
                "Schaumburg",
                "Arlington Heights",
                "Des Plaines",
                "Wheaton",
                "Downers Grove",
                "Rockford",
                "Peoria",
                "Bloomington",
                "Normal",
                "Springfield",
                "Champaign",
                "Urbana",
            ],
        },
        {
            name: "Indiana",
            code: "IN",
            cities: [
                "Indianapolis",
                "Carmel",
                "Fishers",
                "Noblesville",
                "Bloomington",
                "Lafayette",
                "West Lafayette",
                "Fort Wayne",
                "South Bend",
                "Elkhart",
                "Evansville",
            ],
        },
        {
            name: "Iowa",
            code: "IA",
            cities: [
                "Des Moines",
                "West Des Moines",
                "Ankeny",
                "Urbandale",
                "Cedar Rapids",
                "Iowa City",
                "Coralville",
                "Davenport",
                "Bettendorf",
                "Sioux City",
                "Waterloo",
            ],
        },
        {
            name: "Kansas",
            code: "KS",
            cities: [
                "Wichita",
                "Overland Park",
                "Olathe",
                "Lenexa",
                "Shawnee",
                "Lawrence",
                "Manhattan",
                "Topeka",
            ],
        },
        {
            name: "Kentucky",
            code: "KY",
            cities: [
                "Louisville",
                "Lexington",
                "Bowling Green",
                "Owensboro",
            ],
        },
        {
            name: "Louisiana",
            code: "LA",
            cities: [
                "New Orleans",
                "Metairie",
                "Kenner",
                "Baton Rouge",
                "Lafayette",
                "Lake Charles",
                "Shreveport",
                "Bossier City",
            ],
        },
        {
            name: "Maryland",
            code: "MD",
            cities: [
                "Baltimore",
                "Columbia",
                "Towson",
                "Catonsville",
                "Ellicott City",
                "Annapolis",
                "Rockville",
                "Gaithersburg",
                "Bethesda",
                "Silver Spring",
                "Germantown",
                "Frederick",
            ],
        },
        {
            name: "Massachusetts",
            code: "MA",
            cities: [
                "Boston",
                "Cambridge",
                "Somerville",
                "Brookline",
                "Newton",
                "Waltham",
                "Medford",
                "Quincy",
                "Braintree",
                "Weymouth",
                "Lowell",
                "Lawrence",
                "Haverhill",
                "Salem",
                "Peabody",
                "Beverly",
                "Worcester",
                "Springfield",
            ],
        },
        {
            name: "Michigan",
            code: "MI",
            cities: [
                "Detroit",
                "Dearborn",
                "Livonia",
                "Southfield",
                "Troy",
                "Royal Oak",
                "Ferndale",
                "Ann Arbor",
                "Ypsilanti",
                "Lansing",
                "East Lansing",
                "Grand Rapids",
                "Wyoming",
                "Kentwood",
                "Kalamazoo",
                "Battle Creek",
                "Flint",
                "Saginaw",
            ],
        },
        {
            name: "Minnesota",
            code: "MN",
            cities: [
                "Minneapolis",
                "Saint Paul",
                "Bloomington",
                "Edina",
                "Eden Prairie",
                "Minnetonka",
                "Maple Grove",
                "Brooklyn Park",
                "Plymouth",
                "Woodbury",
                "Rochester",
                "Duluth",
            ],
        },
        {
            name: "Missouri",
            code: "MO",
            cities: [
                "St. Louis",
                "Clayton",
                "Chesterfield",
                "St. Charles",
                "Kansas City",
                "Independence",
                "Lee's Summit",
                "Columbia",
                "Springfield",
            ],
        },
        {
            name: "Nevada",
            code: "NV",
            cities: [
                "Las Vegas",
                "North Las Vegas",
                "Henderson",
                "Summerlin",
                "Paradise",
                "Reno",
                "Sparks",
                "Carson City",
            ],
        },
        {
            name: "New Jersey",
            code: "NJ",
            cities: [
                "Newark",
                "Jersey City",
                "Hoboken",
                "Union City",
                "Bayonne",
                "Paterson",
                "Clifton",
                "Passaic",
                "Fort Lee",
                "Englewood",
                "Teaneck",
                "Hackensack",
                "Paramus",
                "Edison",
                "Woodbridge",
                "New Brunswick",
                "Piscataway",
                "Perth Amboy",
                "Elizabeth",
                "Rahway",
                "Plainfield",
                "Westfield",
                "Princeton",
                "Trenton",
                "Cherry Hill",
                "Camden",
            ],
        },
        {
            name: "New York",
            code: "NY",
            cities: [
                "New York City",
                "Yonkers",
                "Mount Vernon",
                "New Rochelle",
                "White Plains",
                "Hempstead",
                "Freeport",
                "Valley Stream",
                "Great Neck",
                "Brooklyn",
                "Queens",
                "Bronx",
                "Manhattan",
                "Staten Island",
                "Buffalo",
                "Niagara Falls",
                "Rochester",
                "Syracuse",
                "Albany",
                "Schenectady",
                "Troy",
                "Utica",
                "Binghamton",
            ],
        },
        {
            name: "North Carolina",
            code: "NC",
            cities: [
                "Charlotte",
                "Concord",
                "Gastonia",
                "Huntersville",
                "Raleigh",
                "Cary",
                "Apex",
                "Durham",
                "Chapel Hill",
                "Greensboro",
                "High Point",
                "Winston-Salem",
                "Fayetteville",
                "Wilmington",
                "Asheville",
            ],
        },
        {
            name: "Ohio",
            code: "OH",
            cities: [
                "Columbus",
                "Dublin",
                "Westerville",
                "Gahanna",
                "Hilliard",
                "Cleveland",
                "Lakewood",
                "Parma",
                "Euclid",
                "Strongsville",
                "Akron",
                "Canton",
                "Youngstown",
                "Cincinnati",
                "Norwood",
                "Blue Ash",
                "Mason",
                "Dayton",
                "Toledo",
            ],
        },
        {
            name: "Oregon",
            code: "OR",
            cities: [
                "Portland",
                "Beaverton",
                "Hillsboro",
                "Tigard",
                "Lake Oswego",
                "Gresham",
                "Vancouver",
                "Salem",
                "Keizer",
                "Eugene",
                "Springfield",
                "Bend",
                "Medford",
            ],
        },
        {
            name: "Pennsylvania",
            code: "PA",
            cities: [
                "Philadelphia",
                "King of Prussia",
                "Conshohocken",
                "Norristown",
                "Upper Darby",
                "Chester",
                "Media",
                "West Chester",
                "Pittsburgh",
                "Monroeville",
                "Cranberry Township",
                "Wexford",
                "Allentown",
                "Bethlehem",
                "Easton",
                "Reading",
                "Lancaster",
                "Harrisburg",
                "York",
                "Erie",
            ],
        },
        {
            name: "South Carolina",
            code: "SC",
            cities: [
                "Charleston",
                "Mount Pleasant",
                "North Charleston",
                "Summerville",
                "Columbia",
                "Lexington",
                "Greenville",
                "Spartanburg",
            ],
        },
        {
            name: "Tennessee",
            code: "TN",
            cities: [
                "Nashville",
                "Franklin",
                "Brentwood",
                "Murfreesboro",
                "Hendersonville",
                "Knoxville",
                "Chattanooga",
                "Cleveland",
                "Memphis",
                "Germantown",
                "Collierville",
            ],
        },
        {
            name: "Texas",
            code: "TX",
            cities: [
                "Houston",
                "Pasadena",
                "Sugar Land",
                "Pearland",
                "The Woodlands",
                "Spring",
                "Katy",
                "Cypress",
                "Dallas",
                "Plano",
                "Frisco",
                "McKinney",
                "Allen",
                "Richardson",
                "Irving",
                "Garland",
                "Arlington",
                "Fort Worth",
                "Grapevine",
                "Southlake",
                "Austin",
                "Round Rock",
                "Cedar Park",
                "Pflugerville",
                "Georgetown",
                "San Antonio",
                "New Braunfels",
                "Schertz",
                "Universal City",
                "El Paso",
                "Laredo",
                "Brownsville",
                "McAllen",
                "Edinburg",
                "Pharr",
                "Corpus Christi",
                "Victoria",
                "Waco",
                "Temple",
                "Killeen",
                "College Station",
                "Bryan",
            ],
        },
        {
            name: "Utah",
            code: "UT",
            cities: [
                "Salt Lake City",
                "West Valley City",
                "South Jordan",
                "West Jordan",
                "Sandy",
                "Draper",
                "Lehi",
                "American Fork",
                "Provo",
                "Orem",
                "Logan",
                "Ogden",
            ],
        },
        {
            name: "Virginia",
            code: "VA",
            cities: [
                "Arlington",
                "Alexandria",
                "Fairfax",
                "Falls Church",
                "McLean",
                "Reston",
                "Herndon",
                "Tysons",
                "Richmond",
                "Henrico",
                "Chesterfield",
                "Virginia Beach",
                "Norfolk",
                "Chesapeake",
                "Newport News",
                "Hampton",
                "Roanoke",
            ],
        },
        {
            name: "Washington",
            code: "WA",
            cities: [
                "Seattle",
                "Bellevue",
                "Redmond",
                "Kirkland",
                "Renton",
                "Issaquah",
                "Bothell",
                "Lynnwood",
                "Everett",
                "Kent",
                "Auburn",
                "Tacoma",
                "Federal Way",
                "Olympia",
                "Bellingham",
                "Spokane",
                "Spokane Valley",
                "Yakima",
                "Kennewick",
                "Richland",
                "Pasco",
            ],
        },
        {
            name: "Wisconsin",
            code: "WI",
            cities: [
                "Milwaukee",
                "Wauwatosa",
                "West Allis",
                "Greenfield",
                "Brookfield",
                "Madison",
                "Middleton",
                "Sun Prairie",
                "Fitchburg",
                "Appleton",
                "Oshkosh",
                "Neenah",
                "Green Bay",
                "Kenosha",
                "Racine",
            ],
        },
    ],
};

/**
 * Maps each US state code to its primary IANA timezone (most-populous region).
 * States spanning multiple zones use the zone of their largest city.
 */
export const STATE_TIMEZONE_MAP: Record<string, string> = {
    AL: 'America/Chicago',
    AK: 'America/Anchorage',
    AZ: 'America/Phoenix',
    AR: 'America/Chicago',
    CA: 'America/Los_Angeles',
    CO: 'America/Denver',
    CT: 'America/New_York',
    DE: 'America/New_York',
    FL: 'America/New_York',
    GA: 'America/New_York',
    HI: 'Pacific/Honolulu',
    ID: 'America/Boise',
    IL: 'America/Chicago',
    IN: 'America/Indiana/Indianapolis',
    IA: 'America/Chicago',
    KS: 'America/Chicago',
    KY: 'America/New_York',
    LA: 'America/Chicago',
    ME: 'America/New_York',
    MD: 'America/New_York',
    MA: 'America/New_York',
    MI: 'America/Detroit',
    MN: 'America/Chicago',
    MS: 'America/Chicago',
    MO: 'America/Chicago',
    MT: 'America/Denver',
    NE: 'America/Chicago',
    NV: 'America/Los_Angeles',
    NH: 'America/New_York',
    NJ: 'America/New_York',
    NM: 'America/Denver',
    NY: 'America/New_York',
    NC: 'America/New_York',
    ND: 'America/Chicago',
    OH: 'America/New_York',
    OK: 'America/Chicago',
    OR: 'America/Los_Angeles',
    PA: 'America/New_York',
    RI: 'America/New_York',
    SC: 'America/New_York',
    SD: 'America/Chicago',
    TN: 'America/Chicago',
    TX: 'America/Chicago',
    UT: 'America/Denver',
    VT: 'America/New_York',
    VA: 'America/New_York',
    WA: 'America/Los_Angeles',
    WV: 'America/New_York',
    WI: 'America/Chicago',
    WY: 'America/Denver',
};

/**
 * Returns the IANA timezone for a US state name or code.
 * Falls back to 'America/New_York' when unknown.
 */
export const getTimezoneForState = (stateNameOrCode: string): string => {
    if (STATE_TIMEZONE_MAP[stateNameOrCode.toUpperCase()]) {
        return STATE_TIMEZONE_MAP[stateNameOrCode.toUpperCase()];
    }
    const state = USA_DATA.states.find(
        (s) => s.name === stateNameOrCode || s.code === stateNameOrCode.toUpperCase()
    );
    return state ? (STATE_TIMEZONE_MAP[state.code] ?? 'America/New_York') : 'America/New_York';
};

// Helper functions
export const getStateByCode = (code: string): State | undefined => {
    return USA_DATA.states.find((state) => state.code === code);
};

export const getStateByName = (name: string): State | undefined => {
    return USA_DATA.states.find((state) => state.name === name);
};

export const getAllUSCities = (): string[] => {
    return USA_DATA.states.flatMap((state) => state.cities);
};

export const getCitiesByStateCode = (stateCode: string): string[] => {
    const state = getStateByCode(stateCode);
    return state ? state.cities : [];
};

export const getCitiesByStateName = (stateName: string): string[] => {
    const state = getStateByName(stateName);
    return state ? state.cities : [];
};

